import { createAction, handleActions } from 'redux-actions';

import { List, Map, fromJS } from 'immutable';
import { pender } from 'redux-pender';
import axios from 'axios';

import * as examLib from 'libs/examLib';
import * as normalizer from 'libs/normalizer';

// action types
const INITIAL_STORE = 'examList/INITIAL_STORE';
const GET_EXAM_LIST = 'examList/GET_EXAM_LIST';
const CHANGE_EXAM_LIST = 'target/CHANGE_EXAM_LIST';
const CHANGE_EXAM_LIST_PARAM = 'currentStatus/CHANGE_EXAM_LIST_PARAM';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const getExamList = createAction(GET_EXAM_LIST, examLib.getExamList);
export const changeExamList = createAction(CHANGE_EXAM_LIST);
export const changeExamListParam = createAction(CHANGE_EXAM_LIST_PARAM);

const initialState = Map({
  // 새로고침
  needReload: false,
  page: 1,
  totalPage: 0,
  totalItem: 0,
  param: Map({
    filter: Map({}),
    sort: [{ field: 'examNo', order: 'DESC' }],
    offset: 0,
    limit: 15
  }),
  examListOrdering: List([]),
  examListByNo: Map({})
});

export default handleActions(
  {
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_EXAM_LIST]: (state, action) => {
      const { name, value } = action.payload;

      return state.set(name, value);
    },
    [CHANGE_EXAM_LIST_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['param', name], value);
    },
    // 훈련 목록 조회
    ...pender({
      type: GET_EXAM_LIST,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }

        const { list } = action.payload.data;
        const { examNo, subTab, refresh, offset, limit } = action.payload.config.params;

        state = state.set('needReload', false);

        let curPage = 1;
        let curArray = [];
        let curData = {};

        if (list.length > 0) {
          const noType =
            (examNo === 'all' && 'examNo') || (subTab === 'pi' && 'targetNo') || (subTab === 'tag' && 'tagNo');

          // 새로고침
          if (refresh) {
            state = state.set('totalPage', Math.ceil(list[0].rnum / limit)).set('totalItem', list[0].rnum);

            curArray = normalizer.examListArrayNormalize(list, noType);
            curData = normalizer.examListNormalize(list, noType);
            // 무한스크롤 요청
          } else {
            curPage = state.get('page') + 1;

            curArray = state
              .get('examListOrdering')
              .toJS()
              .concat(normalizer.examListArrayNormalize(list, noType));
            curData = Object.assign(state.get('examListByNo').toJS(), normalizer.examListNormalize(list, noType));
          }
        } else {
          state = state.set('totalPage', 0).set('totalItem', 0);
        }

        return state
          .set('page', curPage)
          .set('examListOrdering', fromJS(curArray))
          .set('examListByNo', fromJS(curData));
      },
      onFailure: (state, action) => {
        return state
          .set('page', 0)
          .set('examListOrdering', List([]))
          .set('examListByNo', Map({}));
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/examList.js